module.exports = __webpack_public_path__ + "static/img/8.9279959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/8.png
// module id = TqmD
// module chunks = 0